import { createApi } from '@reduxjs/toolkit/query/react';
import {
  TCreateTalentSemanticsFeedbackRequest,
  TCreateTalentSemanticsFeedbackResponse,
  TGetTalentSpecSpellsResponse
} from '../../../../../../../shared/common/talentSemanticsTypes';
import { networkBaseQuery } from '../../../services/api/utils';

type TGetTalentSpecSpellsRequest = { specId: number; dbcIndexVersion: string };

export const talentSemanticsFeedbackApi = createApi({
  reducerPath: 'talentSemanticsFeedbackApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    getTalentSpecSpells: builder.query<TGetTalentSpecSpellsResponse, TGetTalentSpecSpellsRequest>({
      query: ({ specId, dbcIndexVersion }) => ({
        url: `/api/talents/semantics/spec/${specId}/spells`,
        params: { dbcIndexVersion }
      })
    }),
    createTalentSemanticsFeedback: builder.mutation<
      TCreateTalentSemanticsFeedbackResponse,
      TCreateTalentSemanticsFeedbackRequest
    >({
      query: ({ spellId, specId, dbcIndexVersion, issueType, categories, notes }) => ({
        url: '/api/talents/semantics/feedback',
        method: 'POST',
        body: {
          spell_id: spellId,
          spec_id: specId,
          dbc_index_version: dbcIndexVersion,
          issue_type: issueType,
          categories,
          notes: notes || null
        }
      })
    })
  })
});

export const { useGetTalentSpecSpellsQuery, useCreateTalentSemanticsFeedbackMutation } = talentSemanticsFeedbackApi;
